"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomerRegistrationInstructionStatus = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _swr = _interopRequireDefault(require("swr"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _interfaces = require("../../interfaces");
var _TranslationKey = require("../TranslationKey");
async function fetchCustomerRegistrationInstructionStatus(api, registrationIDParam) {
  try {
    const response = await (0, _globalApiClientReact.getCustomerRegistrationInstructionStatus)(api, registrationIDParam);
    return response;
  } catch (error) {
    return error.response;
  }
}
const useCustomerRegistrationInstructionStatus = (onCallbackStatus, registrationID) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    setErrorData
  } = errorData;
  const errorMeesage = formatMessage(_TranslationKey.TranslationKey.cannotGetData);
  return (0, _swr.default)(registrationID ? [registrationID, 'status'] : null, async ([registrationIDProperty]) => {
    const result = await fetchCustomerRegistrationInstructionStatus(api, registrationIDProperty);
    if (result) {
      onCallbackStatus(result.status);
      if (result.status === _globalApiClientReact.HttpStatusCodes.status400BadRequest) {
        const {
          Errors
        } = result.data;
        const submitErrors = Errors?.map(er => ({
          fieldName: er.PropertyName,
          errorCode: er.Code
        }));
        if (submitErrors?.length && submitErrors.length > 0) {
          setErrorData(submitErrors);
        } else {
          setErrorData([]);
        }
      } else if (result.status > 400) {
        setNotificationData({
          isOpen: true,
          message: errorMeesage,
          type: _interfaces.MessageType.error
        });
      }
    }
  });
};
exports.useCustomerRegistrationInstructionStatus = useCustomerRegistrationInstructionStatus;
//# sourceMappingURL=useCustomerRegistrationInstructionStatus.js.map